export default __webpack_public_path__ + "static/integration-experts-ef6f19a1d703d113bf54baa72a27ce2e.png";